import { Component, Input, OnInit } from '@angular/core';
import { DashboardKpiService, LastVsThisMonthSalesAmountSummaryCardComponent, Timespan } from 'gung-dashboard';
import { CultActivityInternalListConfigService } from '../../services/cult-activity-internal-list-config.service';
import { subMonths } from 'date-fns';
import { Subject, takeUntil } from 'rxjs';
import { ActivityInternal } from 'gung-standard';

@Component({
    selector: 'cult-cult-last-vs-this-month-meetings-amount-summary-card',
    templateUrl: './cult-last-vs-this-month-meetings-amount-summary-card.component.html',
    styleUrls: ['./cult-last-vs-this-month-meetings-amount-summary-card.component.scss'],
    standalone: false
})
export class CultLastVsThisMonthMeetingsAmountSummaryCardComponent
  extends LastVsThisMonthSalesAmountSummaryCardComponent
  implements OnInit
{
  protected unsubscribe: Subject<void> = new Subject();
  totalCurrentMonth: string[];
  totalLasMoth: string[];
  completedCurrentMonth: string[];
  completedLastMonth: string[];
  currentDate: Date;

  amountOfCustomers;
  amountOfCustomersWhoOrdered;

  @Input()
  preConditions: any;

  constructor(
    protected dashboardKpiService: DashboardKpiService,
    public cultActivityInternalListConfigService: CultActivityInternalListConfigService
  ) {
    super(dashboardKpiService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.dashboardKpiService
      .getActiveCustomersThisYearComparison(this.preConditions)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe();

    this.cultActivityInternalListConfigService.getItems().subscribe(items => {
      const completeActivities = ['30'];
      this.currentDate = new Date();
      const currentMonth = this.currentDate.getMonth();
      const lastMonth = this.currentDate.getMonth() - 1;

      this.totalCurrentMonth = this.filterItemsByMonth(items, currentMonth);
      this.totalLasMoth = this.filterItemsByMonth(items, lastMonth);
      this.completedCurrentMonth = this.filterItemsByMonth(items, currentMonth, completeActivities);
      this.completedLastMonth = this.filterItemsByMonth(items, lastMonth, completeActivities);
    });
  }

  filterItemsByMonth(items: ActivityInternal[], month: number, status?: string[]): any[] {
    const filteredItems = items.filter(act => {
      const createdDate = new Date(act.date);
      const actDate = new Date(act.activityDate);

      const isMatchingMonth = (date: Date) => date.getMonth() === month;
      const isMatchingStatus = (status: string[]) => status.includes(act.status);
      const isMatchingSalesPerson = (salesPersonId: string) => act.customerResponsible === salesPersonId;

      if (status) {
        if (this.preConditions) {
          return (
            isMatchingMonth(actDate) &&
            isMatchingStatus(status) &&
            isMatchingSalesPerson(this.preConditions.salesPersonId)
          );
        }
        return isMatchingMonth(actDate) && isMatchingStatus(status);
      }

      if (this.preConditions) {
        return isMatchingMonth(actDate) && isMatchingSalesPerson(this.preConditions.salesPersonId);
      }
      return isMatchingMonth(actDate);
    });

    return filteredItems;
  }
}
